import { action, computed, makeObservable, observable } from "mobx";

export type PaymentAmount = {
    amount: number,
    currencyCode: string,
    currencySymbol: string,
    dueDate: Date | undefined
}

export const getDefaultPaymentAmount = () => {
    return {
        amount: 0,
        currencyCode: "",
        currencySymbol: "",
        dueDate: undefined
    };
}

class PaymentStore {
    amountToPay: PaymentAmount = getDefaultPaymentAmount();
    isLoaded = false;
    isValid = false;
    showError = false;

    constructor() {
        makeObservable(this, {
            amountToPay: observable,
            isLoaded: observable,
            isValid: observable,
            showError: observable,

            hasAmountToPay: computed,
            hasAmountToPayBeenSet: computed,

            updateAmountToPay: action,
            updateAmountToPayValue: action,
            updateIsLoaded: action,
            updateShowError: action,
            validate: action,
            reset: action
        });
    }

    get hasAmountToPay() {
        return this.amountToPay && (this.amountToPay.amount ?? 0) > 0;
    }

    get hasAmountToPayBeenSet() {
        return (this.amountToPay?.amount ?? 0) > 0
    }

    updateAmountToPay(value: PaymentAmount) {
        this.amountToPay = value;
        this.validate();
    }

    updateAmountToPayValue(value: number) {
        this.amountToPay.amount = value;
        this.validate();
    }

    updateIsLoaded(value: boolean) {
        this.isLoaded = value;
    }

    updateShowError(value: boolean) {
        this.showError = value;
    }

    validate() {
        this.isValid = (this.amountToPay?.amount ?? 0) > 0;
    }

    reset() {
        this.amountToPay = getDefaultPaymentAmount();
        this.isLoaded = false;
        this.isValid = false;
        this.showError = false;
    }
}

export default PaymentStore;
